import { api } from "./api";

// Shared image upload helper — hits POST /api/images/upload and returns the
// image record `{ image_id, url, filename, alt, ... }`. Throws on validation
// errors so callers can toast a message.
export async function uploadImage(file) {
  if (!file) throw new Error("No file");
  if (!file.type.startsWith("image/")) throw new Error("Only image files are accepted");
  if (file.size > 8 * 1024 * 1024) throw new Error("Image is too large (max 8MB)");
  const fd = new FormData();
  fd.append("file", file);
  const r = await api.post("/images/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return r.data;
}
